import { render, staticRenderFns } from "./giftRequestDetail.vue?vue&type=template&id=3db054ab"
import script from "./giftRequestDetail.vue?vue&type=script&lang=js"
export * from "./giftRequestDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports